import axiosInstance from "utils/axios";
export const getUserProfile = async () => {
  try {
    const response = await axiosInstance.get("/v3/me");
    return response.data;
  } catch (_) {
    return null;
  }
};

export const getIsMembership = async () => {
  try {
    const response = await axiosInstance.post(
      "/v4/mindset/subscription/check-unlock"
    );
    return response.data?.status;
  } catch (_) {
    return false;
  }
};

export const getIsPaidForMindset = async (mindsetSlug: string) => {
  try {
    const response = await axiosInstance.post(
      `/v4/mindset/${mindsetSlug}/check-unlock`
    );
    return response.data?.status;
  } catch (_) {
    return 0;
  }
};
export const getSubscriptionDetails = async () => {
  try {
    const response = await axiosInstance.get("/v4/revenuecat/subscription");
    return response.data;
  } catch (_) {
    return null;
  }
};

export const getRevenueCatPlans = async () => {
  try {
    const response = await axiosInstance.get(
      `/v4/revenuecat/offerings/mindset_membership`
    );
    return response.data.packages;
  } catch (_) {
    return [];
  }
};

/**
 * New function for getting braintree plan
 *
 */
export const getBrainTreePlan = async (planId: string) => {
  try {
    const response = await axiosInstance.get(`/v4/braintree/plan/${planId}`);
    return response.data;
  } catch (_) {
    return null;
  }
};

export const getBrainTreeCoupons = async () => {
  try {
    const response = await axiosInstance.get(`/v4/braintree/coupon`);
    return response.data;
  } catch (_) {
    return null;
  }
};
